export default "__VITE_ASSET__DRDh2iuQ__"